/**
 * Ad Blocker Checker
 *
 * Originally from: https://github.com/ANMedia/ns-web/blob/master/assets/js/modules/adblock-checker.js
 * Note: Modified to fit New Scientist coding standards and requirements.
 */

const hideAdverts = () => {
	const allAdverts = document.querySelectorAll( '.advert' );
	for ( const advert of allAdverts ) {
		advert.style.display = 'none';
	}
};

const showNewsletterSignUp = () => {
	const newsletterSignUp = document.querySelector( '[data-js-sidebar-newsletter-sign-up]' );

	if ( newsletterSignUp ) {
		newsletterSignUp.style.display = 'block';
	}
};

window.onload = function () {
	const adBlocked = document.getElementById( 'ad-bait' );
	const cmsBlockAds = document.querySelector( '[data-js-cms-blockads]' );

	if ( cmsBlockAds && cmsBlockAds.getAttribute( 'data-js-cms-blockads' ) === '1' ) {
		hideAdverts();
		showNewsletterSignUp();
	}

	if ( adBlocked && adBlocked.offsetHeight === 0 ) {
		// dataLayer?.push?.( { event: 'adblock' } ); -- can be uncommented once analytics is set up
		// dataLayer?.push?.( { adblocker: 'yes' } ); -- can be uncommented once analytics is set up
		hideAdverts();
		showNewsletterSignUp();
	} else {
		// dataLayer?.push?.( { adblocker: 'no' } ); -- can be uncommented once analytics is set up
	}
};
